import React from 'react'
import GeoProvider from '../../components/GeoProvider'
import Layout from '../../components/Layout'
import Content from '../../components/Content'
import styles from './TermsofUse.module.scss'
import SystemNotification from './../Dashboard/SystemNotification'
import { useNavigate } from 'react-router-dom'
import TermsofUseOneTrust from './TermsofUseOneTrust'

const TermsofUse = () => {
  return (
    <Layout>
      <Content>
        <GeoProvider>
          <SystemNotification />
        </GeoProvider>
        <TermsofUseOneTrust />
      </Content>
    </Layout>
  )
}

export default TermsofUse
